import { Plus } from 'lucide-react';
import { useState } from 'react';

import { useIntl } from '../../hooks';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui';
import DeviceCreatedNotification from './DeviceCreatedNotification';
import NewDeviceForm from './NewDeviceForm';

interface CreatedDeviceDetails {
  serial: string;
  token: string;
}

export default function AddDeviceDialog() {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [createdDevice, setCreatedDevice] = useState<CreatedDeviceDetails | null>(null);

  const handleClose = () => {
    setOpen(false);
    setCreatedDevice(null);
  };

  const handleFormSuccess = (serial: string, token: string) => {
    setCreatedDevice({ serial, token });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="ml-2">
          <Plus className="h-4 w-4 mr-2" />
          {intl.formatMessage({ id: 'addDevice.addButton' })}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]" aria-description="Dialog to add new device">
        <DialogHeader>
          <DialogTitle>
            {createdDevice
              ? intl.formatMessage({ id: 'addDevice.successTitle' })
              : intl.formatMessage({ id: 'addDevice.title' })}
          </DialogTitle>
          <DialogDescription>
            {createdDevice
              ? intl.formatMessage({ id: 'addDevice.successDescription' })
              : intl.formatMessage({ id: 'addDevice.description' })}
          </DialogDescription>
        </DialogHeader>

        {createdDevice ? (
          <DeviceCreatedNotification
            token={createdDevice.token}
            serial={createdDevice.serial}
            handleClose={handleClose}
          />
        ) : (
          <NewDeviceForm onSuccess={handleFormSuccess} onCancel={handleClose} />
        )}
      </DialogContent>
    </Dialog>
  );
}
